import React from 'react';
import { Link } from 'react-router-dom';
import globals from '../globals';

const Logo = () => {
    return (
        <div className="logo">
            <Link to="/" onClick={() => globals.pushEventClickLogo()}>
                <img src="/images/exetel-logo.svg" alt="Exetel" />
            </Link>
        </div>
    );
};

export default Logo;


// WEBPACK FOOTER //
// ./resources/assets/js/layout/Logo.js